import { SelectItem, ICESGroup } from '../../models'
export class FormatterHelper {

    constructor() { }

    public convertToISODecimal(numberStr: string): number {
        let value = 0;
        if (numberStr) {
            numberStr = numberStr.replace(',', '.');
            value = Number(numberStr);
        }
        return value;
    }

    public getUniqueItems<T>(array: T[]): T[] {
        return array.filter((v, i, a) => v && a.indexOf(v) === i);
    }

    public convertToSelectList(array: number[]): SelectItem[] {
        return array.map(i => new SelectItem(i, i.toString()));
    }

    public getMaxGroup<T extends ICESGroup>(array: T[]): T {
        return array.reduce((a, b) => this.max(a, b));
    }

    public getMinGroup<T extends ICESGroup>(array: T[]): T {
        return array.reduce((a, b) => this.min(a, b));
    }

    public max<T extends ICESGroup>(one: T, two: T): T {
        if (one.Total > two.Total) {
            return one;
        }
        else {
            return two;
        }
    }

    public min<T extends ICESGroup>(one: T, two: T): T {
        if (one.Total < two.Total) {
            return one;
        }
        else {
            return two;
        }
    }    
}